<!-- Services -->
<section id="services">
    <!-- Section Content -->
    <div class="box-white">
        <div class="wrapper padding-all">
            <div class="row">
                <div class="col-md-9 col-sm-12">
                    <!-- <h4 class="title-big">An Integrated Creative Agency</h4> -->
                    <!-- <div class="space"></div> -->
                    <div class="team-horizontal">
                        <!-- Team Members -->
                        <h2 class="line-bottom left">"संचालक मंडळ विषय थोडक्यात माहिती"</h2>
                        <div class="row">
                            <p class="justify">
                                नागपूर महानगर पालिका कर्मचारी सहकारी बँक लि., नागपूर च्या संचालक मंडळ मध्ये २१ सदस्य असतात, त्यात नागपूर महानगर पालिका कर्मचारी सहकारी बँक लि., चे दोन नामांकित कर्मचारी प्रतिनिधींचा समावेश असतो. संचालक मंडळाला नविन सदस्यांना प्रवेश देण्याचे, भागभांडवल
                                वाढवण्याचे कर्ज किंवा इतर खाते आणि विविध भागामध्ये हस्तांतरण मंजुर करण्याचे अधिकार असतात.
                            </p>
                            <p class="justify">
                                व्यवस्थापनाने वार्षिक सर्व साधारण सभेमध्ये वेळोवेळी सुधारणा केल्याप्रमाणे बँकेच्या उपविधींचे पालन करतात यामुळे ग्राहक सेवा अधिक चांगली होण्यास मदत होते. प्रत्येक वर्षी व्यवस्थापनाला त्यांचे सदस्यत्व वाढवावे लागते जेणेकरूण त्याचे फायदे जास्तीत जास्त सदस्यांपर्यंत
                                वाढेल व त्याच्या द्वारे भांडवल वाढेल.
                            </p>
                            <p class="justify">
                                बॅकेच्या विविध उपक्रमांशी संबंधीत अहवाल वार्षिक सभे पुढे ठेवला जातो. वार्षिक लेखा, व्यवस्थापनाचे व बँकेच्या गरजेप्रमाणे उपविधिनमध्ये सुधारणा तसेच महाराष्ट्र सहकारी संस्था अधिनियम १ अंतर्गत १९६०, त्या वर्षासाठी तयार केलेल्या नियमांनुसार समाविष्ट केलेल्या
                                तरतुदी व नफ्याबद्दल तसेच मुनाफा वाटपचे लाभांश निश्चित करण्याचा अहवाल तसेच वित्तिय वर्षा करिता वैधानिक अंकेक्षणा संबंधी सनधी लेखापालाची निवड कवर्षिक आम सभेत विषय ठेवला जातो. वार्षिक आमसभेच्या निर्णयानुसार संचालक मंडळ कार्य
                                करतात.
                            </p>
                            <div class="space"></div>

                            <span>
                              <h2 class="line-bottom left">"वर्तमान संचालक मंडळ २०२२ ते २०२७ "</h2>
                            </span>
                            <div class="space"></div>
                            <div class="col-md-4 col-sm-12" *ngFor="let i of data">
                                <div class="team">
                                    <div class="team-pic">
                                        <a href="team-detail.html "><img src="https://nmpksbank.in/apis/{{i.nmpk_staffPhoto}} " alt="{{i.nmpk_staffName}}" height="250" width="100%" class="img-full "></a>
                                    </div>
                                    <div class="team-detail ">
                                        <div class="detail-social ">
                                            <ul class="social-icons nav-default inline clearfix ">
                                                <li><a href="# " class="facebook "><i class="fa fa-facebook "></i></a></li>
                                                <li><a href="# " class="twitter "><i class="fa fa-twitter "></i></a></li>
                                                <li><a href="# " class="google "><i class="fa fa-google-plus "></i></a></li>
                                                <li><a href="# " class="linkedin "><i class="fa fa-linkedin "></i></a></li>
                                            </ul>
                                        </div>
                                        <div class="detail-name text-bold "><a>{{i.nmpk_staffName}} </a></div>
                                        <div class="detail-title ">{{i.nmpk_staffPost}}</div>
                                        <div class="detail-title ">{{i.nmpk_staffBranch}}</div>
                                    </div>
                                </div>
                                <div class="space "></div>
                            </div>
                        </div>
                        <!-- Team Members End -->
                    </div>
                    <div class="space "></div>
                </div>
                <div class="col-md-3 col-sm-12">
                    <app-side-menu></app-side-menu>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->

</section>

<!-- Services End -->
